import clsx from "clsx";

export const TableSubtabs = ({
  tabs,
  activeTab,
  dataTestid,
  onClick,
  className,
  vertical = false,
}: {
  tabs: string[] | { label: string; value: string; count?: number }[];
  activeTab: string;
  dataTestid?: string;
  onClick: (value: string) => void;
  className?: string;
  vertical?: boolean;
}) => (
  <div
    className={clsx(
      vertical
        ? "flex flex-col gap-y-1"
        : "flex items-center gap-x-3 border-b border-lightGray py-3",
      className,
    )}
    data-testid={dataTestid}
  >
    {tabs.map((tab) => {
      const label = typeof tab === "object" ? tab.label : tab;
      const value = typeof tab === "object" ? tab.value : tab;
      const count =
        typeof tab === "object"
          ? tab.count
            ? Number(tab.count)
            : 0
          : undefined;

      return (
        <button
          key={value}
          type="button"
          className={clsx(
            "flex items-center gap-x-1.5 rounded-lg px-3 py-2.5 text-100 transition-colors",
            vertical
              ? "justify-start text-left"
              : "flex-1 justify-center text-center",
            value === activeTab
              ? "bg-primary-108 font-bold text-primary-300"
              : "text-black-54 hover:bg-black-4 hover:text-black-100",
          )}
          onClick={() => onClick(value)}
        >
          {label}
          {!count ? null : (
            <span className="rounded-full bg-red-100 px-1.5 py-0.5 text-90 text-white-100">
              {count}
            </span>
          )}
        </button>
      );
    })}
  </div>
);
